import { DataTable } from "../DataTable/DataTable";

const LabOrderUpdatedEventTable = () => {
  const headers = ["Status", "Triggers lab_order.updated?", "Notes"];
  const rows = [
    ["not_purchased", "❌", "Internal state only; returned in API"],
    ["purchased", "❌", "Use order.placed webhook"],
    ["schedule_appointment", "❌", "Only relevant for labs that require phlebotomy"],
    ["upcoming_appointment", "❌", "Follows patient scheduling"],
    ["processing", "❌", "Sample received but no results yet"],
    ["partial_results (results_received)", "✅", "Some results available"],
    ["results_ready (all_results_received)", "✅", "All results available"],
    ["results_amended", "✅", "One or more results updated"],
    ["interpretation_shared", "❌ (unless amended)", "May be reached via auto-share settings"],
  ];

  return <DataTable headers={headers} rows={rows} />;
};

export { LabOrderUpdatedEventTable };
